import { LineChart, LineChartProps } from '../../../renderers/line-chart/line-chart.component';
import { FILL_RATE_BY_PRODUCT_LINE_CHART_DEFINITION } from './fill-rate-by-product-line-chart.definition';
import { FILL_RATE_BY_PRODUCT_LINE_CHART_MOCK_DATA } from './fill-rate-by-product-line-chart.mock';

export const FillRateByProductLineChart = (props: LineChartProps) => (
    <LineChart
        {...props}
        showArea
        chartOptions={{
            ...props.chartOptions,
            legend: {
                show: true,
                position: 'bottom',
                ...props.chartOptions?.legend
            }
        }}
    />
);

FillRateByProductLineChart.definition = FILL_RATE_BY_PRODUCT_LINE_CHART_DEFINITION;
FillRateByProductLineChart.mockData = FILL_RATE_BY_PRODUCT_LINE_CHART_MOCK_DATA;
